import "../ClaimDetails.scss";
import { Checkbox, Modal, Table } from "antd";
import CustomLine from "../../../Components/Line/line";
import { LuClipboardList } from "react-icons/lu";
import printIcon from "../../../Assets/img/icons/print.svg";
import { printClaim } from "../../../Services/printClaim";
import getTenantByPayerName from "../../../Helpers/getTenantByPayerName";
import { BsExclamationOctagon } from "react-icons/bs";
import { useMemo, useRef, useState } from "react";
import { rejectAndReturnClaim } from "../../../Services/rejectAndReturnClaim";
import ReturnClaimReasonDialog from "./ReturnClaimReasonDialog";
import { useHistory } from "react-router-dom"
import { GrAttachment } from "react-icons/gr";
import { MdOutlineFileDownload } from "react-icons/md";
import { BsFilePdf } from "react-icons/bs";
import { getB2BTokens } from "../../../AuthService/userData";
const ClaimDetailsDialog = ({
  claimDetails,
  close,
  open,
  payerName,
  messageApi,
}) => {
  const canRejectAndReturn = ((new Date() - new Date(claimDetails.claim.serviceDate || claimDetails.claim.createdAt)) / (1000 * 60 * 60)) <= 72;
  const selectedItems = useRef([]);
  const columns = useMemo(() => {
    return [
      ...canRejectAndReturn ? [{
        title: "تحديد",
        render: (record) => (record.approvalStatus === "Approved"
          ? <Checkbox
            style={{ fontSize: "0.3vw" }}
            onChange={(e) => {
              handleCheckboxChange(e.target.checked, record.id)
            }
            }
          />
          : <></>
        ),
      }] : [],
      {
        title: "اسم الخدمة/الدواء",
        dataIndex: "name",
        key: "name",
        render: (text) => <p>{text}</p>,
      },
      {
        title: "النوع",
        dataIndex: "arabicType",
        key: "arabicType",
        render: (text) => <p>{text}</p>,
      },
      {
        title: "الكمية",
        dataIndex: "quantity",
        key: "quantity",
        render: (text) => <p>{text}</p>,
      },
      {
        title: "سعر الوحدة",
        dataIndex: "unitPrice",
        key: "unitPrice",
        render: (text) => <p>{text}</p>,
      },
      {
        title: "السعر الأجمالى",
        dataIndex: "totalPrice",
        key: "totalPrice",
        render: (text) => <p>{text}</p>,
      },
      {
        title: "قيمة تحمل التأمين",
        dataIndex: "insuranceShare",
        key: "insuranceShare",
        render: (text) => <p>{text}</p>,
      },
      {
        title: "قيمة تحمل المريض",
        dataIndex: "patientShare",
        key: "patientShare",
        render: (text) => <p>{text}</p>,
      },
      {
        title: "حالة الطلب",
        dataIndex: "arabicApprovalStatus",
        key: "arabicApprovalStatus",
        render: (text) => <p>{text}</p>,
      },
      ...canRejectAndReturn ? [{
        title: "استرجاع",
        render: record => (
          record.approvalStatus === "Approved" ? <button
            className="button"
            style={{ fontSize: "0.7vw", whiteSpace: "nowrap", fontWeight: "bold" }}
            onClick={() => {
              setOpenRejectClaimDialogReason({
                open: true,
                itemName: record.name,
                itemType: record.type,
                arabicType: record.arabicType,
                itemID: record.id,
                itemInsuranceShare: record.insuranceShare,
                itemPatientShare: record.patientShare,
                totalPrice: record.totalPrice,
              });
            }}
          >
            استرجاع
          </button>
            : <></>
        )
      }] : [],
    ];
  }, []);
  const [openRejectClaimDialogReason, setOpenRejectClaimDialogReason] = useState({ open: false });
  const [showReturnSomeItems, setShowReturnSomeItems] = useState(false);
  const history = useHistory();

  const handleCheckboxChange = (checked, itemId) => {
    if (checked) {
      selectedItems.current.push(itemId);
    } else {
      selectedItems.current = selectedItems.current.filter((id) => id !== itemId);
    }
    if (selectedItems.current.length > 0)
      setShowReturnSomeItems(true);
    else
      setShowReturnSomeItems(false);
  };

  const handleRevertAllClaim = (allItems, someItems, itemType, itemID, comment, reason) => {
    let types = allItems || someItems ? [] : [itemType === "Medication" ? "dispensedMedication" : "providedServices"];
    let ids = allItems || someItems ? [] : [itemID];

    if (allItems || someItems)
      claimDetails.claim.claimItems.forEach((item) => {
        if ((someItems && selectedItems.current.includes(item.id) && item.approvalStatus === "Approved")
          || (allItems && item.approvalStatus === "Approved")
        ) {
          types.push(item.type === "Medication" ? "dispensedMedication" : "providedServices");
          ids.push(item.id);
        }
      });
    if (ids.length === 0) {
      messageApi.open({
        type: "error",
        content: "لا يوجد خدمات/أدوية متاحة للاسترجاع",
        duration: 7,
      });
      return;
    }
    rejectAndReturnClaim({
      payerName: getB2BTokens()[0].payerName,
      types: types,
      lineItemIds: ids,
      claimId: claimDetails.claim.id,
      reject: true,
      returnApproval: true,
      comment,
      reason,
    }).then((res) => {
      // messageApi.open({
      //   type: "success",
      //   content: "Claim reverted successfully",
      //   duration: 7,
      // });
      // setOpenRejectClaimDialogReason({open:false});
      history.push(`/refresh${window.location.pathname}`);
    }).catch((err) => {
      messageApi.open({
        type: "error",
        content: "Something went wrong please call the support",
        duration: 7,
      });
    });
  };
  return (
    <>
      <Modal
        open={open}
        title={false}
        footer={false}
        direction="rtl"
        closeIcon={true}
        width={"60vw"}
        style={{
          maxHeight: "98vh",
          overflowY: "auto",
          fontSize: "1vw",
          padding: "0",
          borderRadius: "20px",
        }}
        centered
        onCancel={() => {
          close();
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <LuClipboardList style={{ fontSize: "1vw", margin: "0 7px" }} />
          <div>
            <p
              style={{ textAlign: "right", fontSize: "1vw", fontWeight: "bold" }}
            >
              تفاصيل المطالبة
            </p>
            <CustomLine width={"110px"} />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "right",
          }}
        >
          <ul className="ulNormal">
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                اسم المريض:{" "}
              </span>
              {claimDetails.patient.patientName}
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                رقم الكارت:{" "}
              </span>
              {claimDetails.patient.sehatechId}
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                شركة التأمين:{" "}
              </span>
              {claimDetails.patient.insuranceCompany}
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                معرف مقدم الخدمة:{" "}
              </span>
              {claimDetails.providerBranch.id}
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                اسم مقدم الخدمة:{" "}
              </span>
              {claimDetails.providerBranch.name}
            </li>
          </ul>
          <ul className="ulNormal">
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                رقم المطالبة:{" "}
              </span>
              {claimDetails.claim.claimId}
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                تاريخ الطلب:{" "}
              </span>
              {new Date(
                claimDetails.claim.serviceDate || claimDetails.claim.createdAt
              )?.toLocaleDateString("en-GB")}
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                قيمة الطلب:{" "}
              </span>
              {claimDetails.claim.amountPaidByInsurance} ج.م
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                قيمة تحمل المريض:{" "}
              </span>
              {claimDetails.claim.amountPaidByPatient} ج.م
            </li>
            <li>
              <span style={{ fontWeight: "bold", fontSize: "110%" }}>
                حالة الطلب:{" "}
              </span>
              {claimDetails.claim.status}
            </li>
          </ul>
        </div>
        {claimDetails.attachmentURLs?.length > 0 && <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "right",
            alignItems: "center",
            backgroundColor: "#1CC9BC1A",
            borderRadius: "10px",
          }}
        >
          <div style={{ fontSize: "110%", margin: "1%", width: "16%", }}>
            <GrAttachment style={{ fontSize: "1vw", margin: "0 7px" }} />
            المرفقات
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              alignContent: "center",
              margin: "1%",
              flexFlow: "wrap",
              width: "80%",
            }}
          >
            {
              claimDetails.attachmentURLs.map((attachment, i) => (
                <button
                  className="button"
                  key={`attachmentUrlButton${i}`}
                  style={{
                    backgroundColor: "white",
                    color: "black",
                    fontWeight: "normal",
                    lineBreak: "anywhere",
                    padding: "10px",
                    margin: "0 1% 10px 0",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    lineHeight: "1",
                    width: "24%",
                  }}
                  onClick={() => {
                    window.open(attachment.URL, "_blank");
                  }}
                >
                  <BsFilePdf style={{ color: "red", margin: "0 0.5%", width: "10%" }} />
                  <p style={{ width: "78%", fontSize: "90%" }}>
                    {attachment.name}
                  </p>
                  <MdOutlineFileDownload style={{ color: "gray", margin: "0 0.5%", width: "10%" }} />
                </button>
              ))
            }
          </div>
        </div>}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            textAlign: "right",
            alignItems: "center",
          }}
        >
          <div style={{ width: "75%" }}>
            {canRejectAndReturn ? (
              <div
                style={{
                  margin: "10px 0 10px 10px",
                  backgroundColor: "#1CC9BC1A",
                  width: "fit-content",
                  padding: "10px",
                  display: "flex",
                  alignItems: "center",
                  borderRadius: "10px",
                }}
              >
                <BsExclamationOctagon
                  style={{ fontSize: "1vw", margin: "0 7px" }}
                />
                <p
                  style={{
                    fontSize: "0.8vw",
                  }}
                >
                  يمكن استرجاع الخدمات المصروفة فى خلال <span style={{ color: "red" }}>72 ساعة فقط</span> من الصرف{" "}
                </p>
                {showReturnSomeItems && <button
                  className="button"
                  style={{ fontSize: "0.8vw", whiteSpace: "nowrap", fontWeight: "bold" }}
                  onClick={() => {
                    if (selectedItems.current.length === 0) {
                      messageApi.open({
                        type: "error",
                        content: "برجاء تحديد الخدمات/الأدوية المراد استرجاعها.",
                        duration: 7,
                      });
                      return;
                    }
                    setOpenRejectClaimDialogReason({
                      open: true,
                      itemName: "بعض الخدمات/الأدوية",
                      someItems: true,
                    });
                  }}
                >
                  استرجاع الخدمات المحددة
                </button>}
                <button
                  className="button"
                  style={{ margin: "0 20px", fontSize: "0.9vw", whiteSpace: "nowrap", fontWeight: "bold" }}
                  onClick={() => {
                    setOpenRejectClaimDialogReason({ open: true, allItems: true, itemName: "كل الخدمات/الأدوية", itemInsuranceShare: claimDetails.claim.amountPaidByInsurance, itemPatientShare: claimDetails.claim.amountPaidByPatient });
                  }}
                >
                  استرجاع كل الخدمات المصروفة
                </button>
              </div>
            )
              : (
                <div
                  style={{
                    margin: "10px 0 10px 10px",
                    backgroundColor: "#1CC9BC1A",
                    width: "fit-content",
                    padding: "10px",
                    display: "flex",
                    alignItems: "center",
                    borderRadius: "10px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "0.8vw",
                    }}
                  >
                    {" "}
                    <BsExclamationOctagon
                      style={{ fontSize: "1vw", margin: "0 7px" }}
                    />{" "}
                    لقد مر اكثر من <span style={{ color: "red" }}>72 ساعة</span> على الصرف، يمكن التواصل معنا اذا هناك أىٍ مشكلة.{" "}
                  </p>
                </div>
              )
            }
          </div>
          <button
            className="FPOSCreateClaimBtn"
            style={{
              margin: "0 40px",
              padding: "0.5em",
              width: "10em",
              border: "solid 0.1em #535353",
              fontSize: "0.8vw",
              whiteSpace: "nowrap"
            }}
            onClick={() => {
              printClaim(claimDetails.claim.id, {
                headers: {
                  payername: getB2BTokens()[0].payerName,
                  authorization: `Bearer ${
                    getTenantByPayerName(getB2BTokens()[0].payerName).accessToken
                  }`,
                  "Content-Type": undefined,
                },
                responseType: "blob",
              })
                .then((response) => {
                  messageApi.open({
                    type: "success",
                    content: response,
                    duration: 5,
                  });
                })
                .catch((err) => {
                  messageApi.open({
                    type: "error",
                    content:
                      err.message === "Request failed with status code 404"
                        ? "Claim not found"
                        : (Array.isArray(err) && err[0]) ||
                        "Something went wrong",
                    duration: 5,
                  });
                });
            }}
          >
            <img src={printIcon} style={{ margin: "0px 0.3em" }}></img>
            طباعة المطالبة
          </button>
        </div>
        <div
          className="Card"
          style={{ maxHeight: "40vh", overflow: "hidden" }}
        >
          <Table
            columns={columns}
            dataSource={claimDetails.claim.claimItems}
            scroll={{
              y: "25vh",
            }}
            style={{ maxHeight: "40vh" }}
            // rowClassName={classes.Red}
            pagination={false}
          />
        </div>
        <div
          style={{
            margin: "10px 0",
            display: "flex",
            justifyContent: "flex-end",
            position: "sticky",
          }}
        >
          <button
            className="button"
            style={{ fontSize: "1vw" }}
            onClick={() => {
              close();
            }}
          >
            إغلاق
          </button>
        </div>
      </Modal>
      {openRejectClaimDialogReason.open && (
        <ReturnClaimReasonDialog
          open={openRejectClaimDialogReason.open}
          close={() => setOpenRejectClaimDialogReason({ open: false })}
          itemName={openRejectClaimDialogReason.itemName}
          itemType={openRejectClaimDialogReason.itemType}
          arabicType={openRejectClaimDialogReason.arabicType}
          itemInsuranceShare={openRejectClaimDialogReason.itemInsuranceShare}
          itemPatientShare={openRejectClaimDialogReason.itemPatientShare}
          totalPrice={openRejectClaimDialogReason.totalPrice}
          rejectAndReturnClaim={(reasonBody) => handleRevertAllClaim(
            openRejectClaimDialogReason.allItems,
            openRejectClaimDialogReason.someItems,
            openRejectClaimDialogReason.itemType,
            openRejectClaimDialogReason.itemID,
            reasonBody.comment,
            reasonBody.reason
          )}
        />
      )}
    </>
  );
};
export default ClaimDetailsDialog;
